import LocationAdapter from './location-adapter';
import type {
	DataSource,
	USAZip3Location,
	Location,
} from './location-select.types';

let prefixesTable:
	| Record<string, USAZip3Location>
	| PromiseLike<Record<string, USAZip3Location>>;

async function fetchAllPrefixesOnce(): Promise<
	Record<string, USAZip3Location>
> {
	if (prefixesTable) {
		return prefixesTable;
	}

	const {
		default: { data },
	} = await import('./usa-zip3-locations');

	prefixesTable = {};

	for (const location of data) {
		prefixesTable[location.zip3] = location;
	}

	return prefixesTable;
}

async function search(query: string): Promise<USAZip3Location | undefined> {
	const prefixes = await fetchAllPrefixesOnce();
	return prefixes[query];
}

const numeric3Digits = /^\d{3}$/;

export function USAZip3Datasource(): DataSource<Location[]> {
	return {
		type: 'usa-zip3',
		adapter: LocationAdapter,
		async fetch({ query }): Promise<Location[]> {
			if (!numeric3Digits.test(query)) {
				return [];
			}

			const option = await search(query);

			if (!option) {
				return [];
			}

			return [
				{
					tags: ['is_zip3'],
					zipcode: option.zip3,
					address: `${option.state} ${option.zip3}, USA`,
					state: option.state,
					country: 'US',
				},
			];
		},
	};
}
